import React from 'react';
import { LogoLoader } from '../../components/UI/Loader/LogoLoader';
import { connect } from 'react-redux';
import Classes from './style.css';
import Button from "../../components/UI/Button/Button";
import { editBookingReset } from '../../store/actions/editBooking';

export const DeleteBookingComponent = ({ isRequesting, hasError, isSuccessful, translations, history, resetState }) => {
    let component = null;
    if (isRequesting) {
        component = <LogoLoader />;
    } else if (hasError) {
        component = <div>
            <p className={Classes.DeleteText}>{translations.label_error_delete_booking}</p>
            <div className={Classes.SingleButtonsContainer}>
                <Button
                    btnLabel={translations.label_continue}
                    clicked={() => {
                        resetState();
                        history.replace('/');
                    }}
                />
            </div>
        </div>;
    } else if (isSuccessful) {
        component = <div>
            <p className={Classes.DeleteText}>{translations.label_search_success_delete}</p>
            <div className={Classes.SingleButtonsContainer}>
                <Button
                    btnLabel={translations.label_go_to_homepage}
                    clicked={() => {
                        resetState();
                        history.replace('/');
                    }}
                />
            </div>
        </div>;
    }
    return (
        <div className={Classes.ContentContainer}>
            {component}
        </div>
    )
}

export const DeleteBooking = connect(state => ({
    isRequesting: state.deleteBookingState.isRequesting,
    hasError: state.deleteBookingState.hasError,
    isSuccessful: state.deleteBookingState.isSuccessful,
    translations: state.settingsReducer.translations,
}), dispatch => ({
    resetState: () => dispatch(editBookingReset())
}))(DeleteBookingComponent);


// WEBPACK FOOTER //
// ./src/containers/EditBooking/DeleteBooking.js